import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

// Layout
import MainLayout from './layouts/MainLayout';

// Pages
import PersonalInfoPage from './pages/PersonalInfoPage';
import SessionsPage from './pages/SessionsPage';
import ApplicationsPage from './pages/ApplicationsPage';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<PersonalInfoPage />} />
            <Route path="sessions" element={<SessionsPage />} />
            <Route path="applications" element={<ApplicationsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
